import React from 'react'
import Notification, { INotificationProps } from './notification/notification'

interface INotificationsProps {
  notifications: INotificationProps['notification'][]
}

const Notifications = (props: INotificationsProps) => {
  const notifications = props.notifications.map((notification, idx) => {
    return !notification.done ? (
      <Notification key={idx} notification={notification} />
    ) : null
  })
  return <div className="notificationContainer">{notifications}</div>
}

export default Notifications
